import camelCase from 'lodash/camelCase';
import { MAX_LIMIT, DEFAULT_LIMIT } from './config';
import { formatDateRange } from '../../../utils/date-helpers';
import { ISSUE_FILTER_PROPERTIES } from '../../../constants/issue-query-params';

const parseSortParam = (sort) => {
  if (!sort) {
    return 'customIdentifier DESC';
  }
  let sortField = sort;
  let isAscending = true;
  if (sortField.startsWith('-')) {
    sortField = sortField.substring(1);
    isAscending = false;
  }
  if (sortField.startsWith('location')) {
    sortField = 'location';
  }
  return `${camelCase(sortField)} ${isAscending ? 'ASC' : 'DESC'}`;
};

const parseLimit = (limit) => {
  return limit === 'max' ? MAX_LIMIT : limit || DEFAULT_LIMIT;
};

const parseFilterBy = (queryParams = {}) => {
  const parseValue = (param) => (param.constructor === Array ? param.join(',') : param);
  const query = {};

  if (queryParams.targetUrn) {
    query.linkedDocument = queryParams.targetUrn;
    query.linkedDocumentVersion = queryParams.documentVersion;
  }
  if (
    queryParams[ISSUE_FILTER_PROPERTIES.STATUS_FILTER] &&
    queryParams[ISSUE_FILTER_PROPERTIES.STATUS_FILTER].length > 0
  ) {
    query.status = parseValue(queryParams[ISSUE_FILTER_PROPERTIES.STATUS_FILTER]);
  }
  if (
    queryParams[ISSUE_FILTER_PROPERTIES.ASSIGNED_TO_FILTER] &&
    queryParams[ISSUE_FILTER_PROPERTIES.ASSIGNED_TO_FILTER].length > 0
  ) {
    query.assignedTo = parseValue(queryParams[ISSUE_FILTER_PROPERTIES.ASSIGNED_TO_FILTER]);
  }
  if (
    queryParams[ISSUE_FILTER_PROPERTIES.CREATED_BY_FILTER] &&
    queryParams[ISSUE_FILTER_PROPERTIES.CREATED_BY_FILTER].length > 0
  ) {
    query.createdBy = parseValue(queryParams[ISSUE_FILTER_PROPERTIES.CREATED_BY_FILTER]);
  }
  if (queryParams[ISSUE_FILTER_PROPERTIES.COST_IMPACT]) {
    query.costImpact = queryParams[ISSUE_FILTER_PROPERTIES.COST_IMPACT];
  }
  if (queryParams[ISSUE_FILTER_PROPERTIES.SCHEDULE_IMPACT]) {
    query.scheduleImpact = queryParams[ISSUE_FILTER_PROPERTIES.SCHEDULE_IMPACT];
  }
  if (queryParams[ISSUE_FILTER_PROPERTIES.PRIORITY]) {
    query.priority = queryParams[ISSUE_FILTER_PROPERTIES.PRIORITY];
  }
  if (queryParams[ISSUE_FILTER_PROPERTIES.DISCIPLINE]) {
    query.discipline = queryParams[ISSUE_FILTER_PROPERTIES.DISCIPLINE];
  }
  if (queryParams[ISSUE_FILTER_PROPERTIES.CATEGORY]) {
    query.category = queryParams[ISSUE_FILTER_PROPERTIES.CATEGORY];
  }
  if (queryParams[ISSUE_FILTER_PROPERTIES.SEARCH]) {
    query.search = queryParams[ISSUE_FILTER_PROPERTIES.SEARCH];
  }
  if (
    queryParams[ISSUE_FILTER_PROPERTIES.CREATED_AT_START_FILTER] &&
    queryParams[ISSUE_FILTER_PROPERTIES.CREATED_AT_END_FILTER]
  ) {
    query.createdAt = formatDateRange(
      queryParams[ISSUE_FILTER_PROPERTIES.CREATED_AT_START_FILTER],
      queryParams[ISSUE_FILTER_PROPERTIES.CREATED_AT_END_FILTER]
    );
  }
  if (
    queryParams[ISSUE_FILTER_PROPERTIES.DUE_DATE_START_FILTER] &&
    queryParams[ISSUE_FILTER_PROPERTIES.DUE_DATE_END_FILTER]
  ) {
    query.dueDate = formatDateRange(
      queryParams[ISSUE_FILTER_PROPERTIES.DUE_DATE_START_FILTER],
      queryParams[ISSUE_FILTER_PROPERTIES.DUE_DATE_END_FILTER]
    );
  }
  if (queryParams[ISSUE_FILTER_PROPERTIES.INCLUDE_HIDDEN_FILTER]) {
    query.includeHidden = true;
  }
  return query;
};

const buildGetRfisRequest = (request) => {
  const limit = parseLimit(request.limit);
  const offset = request.offset ? request.offset : 0;
  const { targetUrn } = request;
  const { documentVersion } = request;

  const { sort, ...queryParams } = request && request.queryParams ? request.queryParams : {};

  const filterByParams = { targetUrn, documentVersion, ...queryParams };
  const isHasFilter = !!Object.values(filterByParams).filter((v) => v !== undefined).length;
  return {
    limit,
    offset,
    ...(sort && { sortBy: parseSortParam(sort) }),
    ...(isHasFilter && { filterBy: parseFilterBy(filterByParams) }),
  };
};
export default buildGetRfisRequest;
